<template>
    <div itemprop="breadcrumb" class="menu-breadcrumbs">
        <template v-for="(breadcrumb, index) in breadcrumbs">
        <a v-if="breadcrumb.url && index < breadcrumbs.length - 1" :href="breadcrumb.url" :title="breadcrumb.title">{{ breadcrumb.title }}</a>
        <span v-else>{{ breadcrumb.title }}</span>
        <span v-if="index < breadcrumbs.length - 1" class="separator"></span>
        </template>

        <span
            v-if="productCounts"
            class="product-counter">
            <strong>{{ productCounts }} </strong>
            {{ __('termék') }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumbs',

    props: {
        breadcrumbs: {
            type: Array,
            required: true,
        },
        productCounts: {
            type: Number,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
